import React from 'react';
import {Edit, SimpleForm, TextInput, NumberInput, Toolbar, SaveButton} from 'react-admin';

const CashbackConditionsEditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

class CashbackConditionsEdit extends React.Component {
    render() {
        return (
            <Edit {...this.props}>
                <SimpleForm toolbar={<CashbackConditionsEditToolbar />}>
                    <TextInput source="margin" label="Margin" fullWidth />
                    <TextInput source="fontSize" label="Font Size" fullWidth />
                    <NumberInput source="position" label="Position" />
                </SimpleForm>
            </Edit>
        );
    }
}

export default CashbackConditionsEdit;
